import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import alertify from 'alertifyjs/build/alertify.min.js';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import VeeValidate from 'vee-validate';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VueGtag from "vue-gtag";

window.alertify = alertify;

alertify.set('notifier', 'delay', 5);
alertify.set('notifier', 'position', 'top-center');
alertify.set('prompt', 'reverseButtons', true);
alertify.set('prompt', 'transition', 'fade');
alertify.set('confirm', 'transition', 'fade');

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
	events: 'blur',
	classes: true
});

Vue.mixin({
	methods: {
		focusOut(event) {
			event.target.blur()
		}
	}
});

if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: 'https://' + process.env.VUE_APP_SENTRY_KEY + '@sentry.hellofirstview.com/' + process.env.VUE_APP_SENTRY_PROJECT,
		integrations: [new Integrations.Vue({Vue, attachProps: true})],
	});
} else {
	// You may remove this once you are sure everything works fine
	// console.debug('Not configuring Sentry, environment is', process.env.NODE_ENV);
	// console.debug('BASE URL', process.env.BASE_URL);
}

Vue.use(VueGtag, {
  config: { id: "UA-156971159-1" }
});

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');
